const API_REACHABILITY_UNKNOWN = 'unknown';
const API_REACHABILITY_ONLINE = 'online';
const API_REACHABILITY_OFFLINE = 'apiOffline';

let reachability = API_REACHABILITY_UNKNOWN;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => {
    try {
      listener(reachability);
    } catch (error) {
      console.warn(
        '[apiReachability] Reachability listener failed; continuing.',
        error
      );
    }
  });
};

export const getApiReachability = () => reachability;

export const subscribeApiReachability = (listener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const reportApiReachable = () => {
  if (reachability === API_REACHABILITY_ONLINE) {
    return;
  }

  reachability = API_REACHABILITY_ONLINE;
  notify();
};

export const reportApiUnreachable = () => {
  if (reachability === API_REACHABILITY_OFFLINE) {
    return;
  }

  reachability = API_REACHABILITY_OFFLINE;
  notify();
};

export const resetApiReachabilityForTests = () => {
  if (reachability === API_REACHABILITY_UNKNOWN) {
    return;
  }

  reachability = API_REACHABILITY_UNKNOWN;
  notify();
};
